<li class="row row-cols-auto border rounded py-2 px-3 mb-1">
    <div [matTooltip]="getOccurrenceDateDetail(occurrence)" class="occurrence-detail col">
        <i class="fa-regular fa-calendar-range pe-2"></i> {{getOccurrenceDate(occurrence, poll.recurrence.frequency) }}
    </div>
    <div class="col">
        @switch (occurrence.status){
            @case('LiveQuestionStatus'){
                <small class="ps-5 text-secondary" [matTooltip]="getLiveOccurrenceDateDetail(occurrence)">
                    <i class="fa-solid fa-circle-small text-success px-1"></i>{{ 'polls_settings.occurrence.live' | translate}} {{ getOccurrenceParticipation(occurrence.teams)}}
                </small>
                <button class="btn btn-outline-secondary btn-sm py-1 ms-5" [ngClass]="{'me-2': occurrence.isDeletable}"
                        (click)="sendReminder(poll)">
                    <i class="far fa-paper-plane pe-1"></i> {{ 'polls_settings.notify_users' | translate}}
                </button>
            }
            @case('FinishedQuestionStatus'){
                @if(getOccurrenceParticipation(occurrence.teams) > 0){
                    <button class="btn btn-outline-primary btn-sm py-1 ms-5" (click)="showPollResultDialog(poll, occurrence.pollOccurrenceId)">
                        <i class="far fa-chart-line pe-1"></i> {{ 'polls_settings.show_results' | translate}} ({{'poll_results.participation' | translate}} {{getOccurrenceParticipation(occurrence.teams)}})
                    </button>
                }@else{
                    <small class="ps-5 text-secondary">
                        {{ 'polls_settings.show_results.no_participation' | translate}}
                    </small>
                }
            }
        }
    </div>
    <div class="col">
        @if(occurrence.isDeletable){
            <button type="button" class="btn btn-outline-danger btn-sm py-1 ms-5" data-cy="removeQuestion"
                    (click)="remove(occurrence)">
                    <i class="far fa-trash-alt"></i> {{ 'polls_settings.delete_poll' | translate}}
            </button>
        }
    </div>                                
</li>